import { Source, Layer } from "@vis.gl/react-maplibre";
import { useMemo } from "react";

import { POLYGON_OPACITY, POLYGON_STROKE_WIDTH } from "@/constants/map";

const PolygonOnMap = ({ value, color }) => {
  const polygonGeoJSON = useMemo(() => {
    if (!value) return null;

    // один полигон
    if (Array.isArray(value)) {
      const coordinates = value.map(({ lat, lon }) => [lon, lat]);
      // Замыкаем полигон, если первая и последняя точки не совпадают
      if (
        coordinates[0][0] !== coordinates[coordinates.length - 1][0] ||
        coordinates[0][1] !== coordinates[coordinates.length - 1][1]
      ) {
        coordinates.push(coordinates[0]);
      }

      return {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [coordinates],
        },
      };
    }

    //несколько полигонов
    if (value.polygons?.length) {
      const multiCoordinates = value.polygons.map((polygon) => {
        const coords = polygon.map(({ lat, lon }) => [lon, lat]);

        if (
          coords[0][0] !== coords[coords.length - 1][0] ||
          coords[0][1] !== coords[coords.length - 1][1]
        ) {
          coords.push(coords[0]);
        }

        return [coords];
      });

      return {
        type: "Feature",
        geometry: {
          type: "MultiPolygon",
          coordinates: multiCoordinates,
        },
      };
    }

    return null;
  }, [value]);

  if (!polygonGeoJSON) return null;

  return (
    <Source type="geojson" data={polygonGeoJSON}>
      <Layer
        type="fill"
        paint={{
          "fill-color": color,
          "fill-opacity": POLYGON_OPACITY,
        }}
      />
      <Layer
        type="line"
        paint={{
          "line-color": color,
          "line-width": POLYGON_STROKE_WIDTH,
        }}
      />
    </Source>
  );
};

export default PolygonOnMap;
